"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Select = _interopRequireDefault(require("../../elements/select/Select"));

var _eyeDisable = _interopRequireDefault(require("../../images/eye-disable.svg"));

var _eyeEnable = _interopRequireDefault(require("../../images/eye-enable.svg"));

var _stitches = require("../../stitches.config");

var _Birthday = _interopRequireDefault(require("./birthday/Birthday"));

var _shared = require("./shared");

var StyledInputBoxWrapper = (0, _stitches.styled)('div', {
  marginBottom: '10px',
  marginTop: '10px'
});
var StyledInputBox = (0, _stitches.styled)('div', {
  alignItems: 'center',
  border: '1px solid $inputBorder',
  borderRadius: '5px',
  display: 'flex',
  padding: '2px',
  position: 'relative',
  '&:focus-within': {
    border: '1px solid $inputBorderFocused'
  },
  variants: {
    errored: {
      true: {
        borderColor: '$red'
      }
    }
  }
});
var StyledLabel = (0, _stitches.styled)('label', {
  backgroundColor: '$white',
  color: '$textPrimary',
  fontSize: '$xSmall',
  fontWeight: '$semiBold',
  left: '15px',
  padding: '0 3px',
  position: 'absolute',
  top: '-7px',
  zIndex: '2'
});
var StyledRequiredMark = (0, _stitches.styled)('span', {
  color: '$red',
  fontSize: '$xSmall'
});
var StyledShowHideButton = (0, _stitches.styled)('button', {
  background: 'transparent',
  border: 'none',
  borderRadius: '5px',
  outline: 'none',
  '&:focus': {
    border: '2px solid $inputBorderFocused'
  },
  '&:hover': {
    cursor: 'pointer'
  }
});
var StyledErrorMessage = (0, _stitches.styled)('div', {
  color: '$red',
  fontSize: '$xSmall',
  marginLeft: '10px',
  marginTop: '5px'
});
/**
 * An input component used in forms that has validation capabilties.
 */

var Input = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _typeMapping$type;

  var errorMessage = _ref.errorMessage,
      id = _ref.id,
      initialValue = _ref.initialValue,
      label = _ref.label,
      options = _ref.options,
      name = _ref.name,
      placeholder = _ref.placeholder,
      required = _ref.required,
      type = _ref.type,
      visible = _ref.visible;

  var _useState = (0, _react.useState)(type),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      inputType = _useState2[0],
      setInputType = _useState2[1];

  var toggleType = function toggleType() {
    if (inputType === 'password') {
      setInputType('text');
    } else {
      setInputType('password');
    }
  };

  var typeMapping = {
    birthday: /*#__PURE__*/_react.default.createElement(_Birthday.default, {
      id: id,
      initialValue: initialValue,
      placeholder: placeholder,
      ref: ref
    }),
    input: /*#__PURE__*/_react.default.createElement(_shared.StyledInput, {
      "aria-label": placeholder,
      id: id,
      name: name,
      placeholder: placeholder,
      ref: ref,
      type: inputType
    }),
    select: /*#__PURE__*/_react.default.createElement(_Select.default, {
      id: id,
      name: name,
      options: options,
      ref: ref
    })
  };
  return visible && /*#__PURE__*/_react.default.createElement(StyledInputBoxWrapper, null, /*#__PURE__*/_react.default.createElement(StyledInputBox, {
    errored: Boolean(errorMessage)
  }, /*#__PURE__*/_react.default.createElement(StyledLabel, {
    htmlFor: id
  }, label, required && /*#__PURE__*/_react.default.createElement(StyledRequiredMark, null, " *")), (_typeMapping$type = typeMapping[type]) !== null && _typeMapping$type !== void 0 ? _typeMapping$type : typeMapping.input, type === 'password' && /*#__PURE__*/_react.default.createElement(StyledShowHideButton, {
    type: "button",
    onClick: toggleType
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "show/hide",
    src: inputType === 'password' ? _eyeDisable.default : _eyeEnable.default
  }))), /*#__PURE__*/_react.default.createElement(StyledErrorMessage, null, errorMessage));
});
Input.defaultProps = {
  errorMessage: '',
  id: '',
  initialValue: '',
  label: '',
  options: [],
  placeholder: '',
  required: false,
  visible: true
};
Input.displayName = 'Input';
var _default = Input;
exports.default = _default;